export default __webpack_public_path__ + "static/media/logo-no-text.691a2bb4.svg";